{
  "version": 1,
  "asset_id": "7beffa17-da90-4366-b413-01a3bd8ad8e1",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/7beffa17-da90-4366-b413-01a3bd8ad8e1/loc-frisco-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/7beffa17-da90-4366-b413-01a3bd8ad8e1/loc-frisco-1280.avif",
  "original_filename": "loc-frisco-1280.avif",
  "size": 48824,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:24Z"
}
